import { normalizedUuidSchema } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import { useNavigate, useParams } from 'react-router';
import { EmptyState } from '@/shared/ui';
import { PaymentDetailHeader, PaymentDetailPanel } from '@/widgets/payment-detail';

/**
 * 어드민 결제 상세(/payments/:paymentId) — 주소 해석과 "목록으로" 이동만 하고, 머리말(결제 상태 배지)과 내용은 위젯이 그린다.
 * 올바르지 않은 주소는 머리말 아래 카드 안 가운데 안내로 알린다.
 */
export const PaymentDetailPage = (): ReactElement => {
  const navigate = useNavigate();
  const { paymentId } = useParams<{ paymentId: string }>();
  const parsed = normalizedUuidSchema.safeParse(paymentId);
  const goToList = (): void => {
    void navigate('/payments');
  };

  if (!parsed.success) {
    return (
      <>
        <PaymentDetailHeader status={null} onBack={goToList} />
        <EmptyState isError>올바른 결제 주소가 아닙니다.</EmptyState>
      </>
    );
  }

  return <PaymentDetailPanel key={parsed.data} paymentId={parsed.data} onBack={goToList} />;
};
